module.exports = __webpack_public_path__ + "sunsemweb/img/13.9a582486.png";